import { TFunction } from "next-i18next";
import { UTSLocale } from "@smile2impress/attraction-constants";
import { withCdnUrl } from "@smile2impress/attraction-utils";

import { PageContentProps } from "content/content.types";
import { UrlsConfig } from "configs/urlsConfig";
import Link from "components/Link";

const getPageData = (t: TFunction, { locale }: PageContentProps) => {
    return {
        title: t("blog:pageTitle"),
        readMoreText: t("blog:readMoreLink"),
        readTimeText: t("blog:timeForReading"),
        sideBanner: {
            bg: withCdnUrl("/images/blog/blogs-all.jpg"),
            button: {
                name: t("blog:buttonText"),
                link: UrlsConfig.UNIVERSAL_FORM,
                as: Link,
            },
        },
        locale,
    };
};

export default (locale: UTSLocale) => {
    switch (locale) {
        case UTSLocale.FRANCE_FR:
        case UTSLocale.ITALY_IT:
        case UTSLocale.PORTUGAL_PT:
        case UTSLocale.SPAIN_ES:
        case UTSLocale.GB_EN:
        case UTSLocale.US_EN:
        case UTSLocale.UKRAINE_UK:
        case UTSLocale.NL_NL:
        case UTSLocale.SWEDEN_SE:
        case UTSLocale.GERMANY_DE:
            return getPageData;
        default:
            return () => null;
    }
};
